// extracted by mini-css-extract-plugin
export default {"grid":"CampaignGridFullWidth_grid__eFvr-"};